module.exports = __webpack_public_path__ + "static/media/centerBg.e1c92ec0.png";